/* eslint-disable sort-keys */
export const VAST_XML_PARSING_ERROR = 100;
export const VAST_SCHEMA_VALIDATION_ERROR = 101;
export const VAST_UNSUPPORTED_VERSION = 102;
export const VAST_UNEXPECTED_AD_TYPE = 200;
export const VAST_UNEXPECTED_LINEARITY = 201;
export const VAST_UNEXPECTED_DURATION_ERROR = 202;
export const VAST_UNEXPECTED_MEDIA_FILE = 203;
export const VAST_WRAPPER_ERROR = 300;
export const VAST_LOAD_TIMEOUT = 301;
export const VAST_TOO_MANY_REDIRECTS = 302;
export const VAST_NO_ADS_AFTER_WRAPPER = 303;
export const VIDEO_PLAY_ERROR = 400;
export const VAST_MEDIA_FILE_NOT_FOUND = 401;
export const VAST_MEDIA_LOAD_TIMEOUT = 402;
export const VAST_LINEAR_ASSET_MISMATCH = 403;
export const VAST_PROBLEM_DISPLAYING_MEDIA_FILE = 405;
export const VAST_NONLINEAR_PLAYING_FAILED = 500;
export const VAST_NONLINEAR_DIMENSIONS_ERROR = 501;
export const VAST_NONLINEAR_LOADING_FAILED = 502;
export const VAST_NONLINEAR_ASSET_MISMATCH = 503;
export const UNKNOWN_ERROR = 900;
export const VPAID_ERROR = 901;

export const errorCodes = {
  VAST_XML_PARSING_ERROR,
  VAST_SCHEMA_VALIDATION_ERROR,
  VAST_UNSUPPORTED_VERSION,
  VAST_UNEXPECTED_AD_TYPE,
  VAST_UNEXPECTED_LINEARITY,
  VAST_UNEXPECTED_DURATION_ERROR,
  VAST_UNEXPECTED_MEDIA_FILE,
  VAST_WRAPPER_ERROR,
  VAST_LOAD_TIMEOUT,
  VAST_TOO_MANY_REDIRECTS,
  VAST_NO_ADS_AFTER_WRAPPER,
  VIDEO_PLAY_ERROR,
  VAST_MEDIA_FILE_NOT_FOUND,
  VAST_MEDIA_LOAD_TIMEOUT,
  VAST_LINEAR_ASSET_MISMATCH,
  VAST_PROBLEM_DISPLAYING_MEDIA_FILE,
  VAST_NONLINEAR_PLAYING_FAILED,
  VAST_NONLINEAR_DIMENSIONS_ERROR,
  VAST_NONLINEAR_LOADING_FAILED,
  VAST_NONLINEAR_ASSET_MISMATCH,
  UNKNOWN_ERROR,
  VPAID_ERROR
};

export const isVastErrorCode = (code) => Object.values(errorCodes).includes(code);
